import React from 'react';
import { CheckCircle2 } from 'lucide-react';
import AirBoardPage from './AirBoardPage';
import { SUBESTADOS_FINALIZADAS } from '../utils/airBoardConstants';

/** Tablero "Finalizadas" del aéreo — solicitudes en estado `Aprobada`. */
const ACCIONES_ESTADO = [
  {
    key: 'archive',
    icon: 'Archive',
    tooltip: 'Archivar',
    confirmar: null,
    cambio: { subEstado: 'Archivada' },
    exito: 'Archivada',
    error: 'No se pudo archivar',
  },
  {
    key: 'reabrir',
    icon: 'RotateCcw',
    tooltip: 'Reabrir y volver a Operaciones en curso',
    confirmar: (codigo) => `¿Reabrir la operación ${codigo}? Volverá a Operaciones en curso.`,
    cambio: { estado: 'Enviada' },
    exito: 'Operación reabierta',
    error: 'No se pudo reabrir',
  },
];

export default function CompletedBoardPage() {
  return (
    <AirBoardPage
      estado="Aprobada"
      titulo="Finalizadas"
      subtitulo="Solicitudes en estado Aprobada · entregadas y archivadas"
      icon={CheckCircle2}
      iconClass="bg-emerald-100 text-emerald-700"
      subEstadoOptions={SUBESTADOS_FINALIZADAS}
      subEstadoDefault="Cerrada"
      exportFileName="aereo_finalizadas"
      accionesEstado={ACCIONES_ESTADO}
    />
  );
}
